/**
 * Extracts a human-readable error message from an axios-style failure.
 * Prefers the BlazeMeter envelope's `response.data.error.message` (set by
 * the backend for structured 4xx/5xx errors), falls back to axios's
 * `error.message`, then to `String(error)`.
 */
export const extractErrorMessage = (error: unknown): string => {
  const anyErr = error as { response?: { data?: { error?: { message?: string } } }; message?: string };
  return anyErr?.response?.data?.error?.message ?? anyErr?.message ?? String(error);
};
